import { http } from '../helpers/HttpApi';

const transactionApi = {
    getXReport: async (storeId: number, registerName: string) => {
        const result = await http
            .get(`/api/transaction/register/xreport/${storeId}/${registerName}`)
            .then((data) => data);

        return result;
    },
    openRegister: (request: any) => {
        return http
            .post(`/api/transaction/register/open`, request)
            .then(res => res?.data);
    },
    closeRegister: async (request: any) => {
        const result = await http
            .post(`/api/transaction/register/close`, request)
            .then(res => res?.data);

        return result;
    }
};

export default transactionApi;
